import { cx } from '@/utils/cx';
import type { OrderStatus } from '@/types/order';
import styles from './StatusChip.module.scss';

const LABELS: Record<OrderStatus, string> = {
  completed: 'Completed',
  processing: 'Processing',
  failed: 'Failed',
};

const STYLE_KEY: Record<OrderStatus, string> = {
  completed: styles.completed,
  processing: styles.processing,
  failed: styles.failed,
};

export interface StatusChipProps {
  status: OrderStatus;
}

export function StatusChip({ status }: StatusChipProps) {
  return <span className={cx(styles.chip, STYLE_KEY[status])}>{LABELS[status]}</span>;
}
